(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["apm-product-recommendations"] && !Shopify.designMode) return;
  try {
    

(function() {

  function loadAPMRecommendations() {

    const sections = document.querySelectorAll(
      '.apm-recommendations[data-product-id]'
    );

    sections.forEach(function(section) {

      if (section.dataset.loaded === 'true') return;

      const productId = section.dataset.productId;
      const sectionId = section.dataset.sectionId;
      const limit = section.dataset.limit || 4;

      if (!productId || !sectionId) return;

      section.dataset.loaded = 'true';

      const url =
        window.Shopify.routes.root +
        'recommendations/products?section_id=' +
        encodeURIComponent(sectionId) +
        '&product_id=' +
        encodeURIComponent(productId) +
        '&limit=' +
        encodeURIComponent(limit) +
        '&intent=related';

      fetch(url)
        .then(function(response) {
          if (!response.ok) {
            throw new Error('Recommendations request failed');
          }

          return response.text();
        })
        .then(function(text) {

          const html = document.createElement('div');
          html.innerHTML = text;

          const newSection = html.querySelector(
            '#APM-Recommendations-' + CSS.escape(sectionId)
          );

          if (!newSection) return;

          if (newSection.innerHTML.trim() === '') {
            section.style.display = 'none';
            return;
          }

          section.innerHTML = newSection.innerHTML;

        })
        .catch(function(error) {
          console.warn('APM recommendations:', error);
        });

    });

  }


  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      loadAPMRecommendations
    );

  } else {

    loadAPMRecommendations();

  }


  document.addEventListener(
    'shopify:section:load',
    loadAPMRecommendations
  );

})();


  } catch(e) { console.error(e); }
})();
})();
